import { HTTP } from "../../service/helper";

// initial state
const state = () => ({
   topupLists: "",
   paymentType: "",
});

// getters
const getters = {
   getTopupLists(state) {
      return state.topupLists;
   },
   getPaymentTypeLists(state) {
      return state.paymentType;
   }
};

// actions
const actions = {

   topupProcess(_,data){

      return new Promise((resolve, reject) => {

         HTTP.post("/v1/topup-transactions",data)
            .then((response) => {
               resolve(response);
            })
            .catch((error) => {
               reject(error.response.data);
            });
      });
      
   },
   paymenttype(){
      return new Promise((resolve, reject) => {
         HTTP.get("/v1/paymenttype-list/1")
            .then((response) => {
               resolve(response);
            })
            .catch((error) => {
               reject(error.response.data);
            });
      });
   },
   getPhoneNumbers(){
      return new Promise((resolve, reject) => {
         HTTP.get("/v1/phonenumbers")
            .then((response) => {
               resolve(response);
            })
            .catch((error) => {
               reject(error.response.data);
            });
      });
   },
   topupPackages(_,operator){
      return new Promise((resolve, reject) => {
         HTTP.get("/v1/topup-packages/operators/"+operator)
            .then((response) => {
               resolve(response);
            })
            .catch((error) => {
               reject(error.response.data);
            });
      });
   }
};

// mutations
const mutations = {
   setTopupLists(state, payload) {
      state.topupLists = payload;
   },
   // setPaymentTypeList(state, payload){
   //    state.paymentType = payload
   // }
};

export default {
   namespaced: true,
   state,
   getters,
   actions,
   mutations,
};
